import { RM_ASSOCIATION_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/rm_association_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
